import * as React from 'react';

const ContactCard = props => {
  const { card } = props;

  return (
    <div className="rounded-lg shadow-lg max-w-md overflow-hidden">
      <iframe
        src={card.iframe.url}
        title={card.iframe.title}
        width="512"
        height="150"
        style={{ border: '0' }}
        loading="lazy"
        className="w-full"
      />
      <div className="bg-white px-4 py-5 sm:px-6">
        <h3 className="text-lg leading-6 font-semibold text-base-content">
          {' '}
          {card.title}
        </h3>
        <address className="mt-1 text-sm text-neutral not-italic">
          {card.address}
        </address>
      </div>
      <dl className="grid grid-cols-1 gap-x-4 gap-y-8  px-4 pb-5 sm:(px-6 grid-cols-2)">
        <div className="sm:col-span-1">
          <dt className="text-sm font-semibold text-neutral"> Call</dt>
          <dd className="mt-1 ">
            <a
              href={`tel:${card.phone}`}
              className="block text-sm text-base-content transition can-hover:hover:text-primary w-[fit-content]"
            >
              {card.phone}
            </a>
          </dd>
        </div>
        <div className="sm:col-span-1">
          <dt className="text-sm font-semibold text-neutral"> Fax</dt>
          <dd className="mt-1 text-sm text-base-content"> {card.fax}</dd>
        </div>
      </dl>
    </div>
  );
};

export default function ContactSectionTwoCards(props) {
  const { title, description, contactCards } = props;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="text-3xl font-extrabold text-base-content"> {title}</h2>
      <p className="mt-6 text-lg text-neutral max-w-3xl"> {description}</p>
      <div className="mt-10 grid gap-10 sm:grid-cols-2">
        {contactCards.map(card => (
          <ContactCard key={card.id} card={card} />
        ))}
      </div>
    </div>
  );
}
